import script from "./LogEventsGrid.vue?vue&type=script&setup=true&lang=ts"
export * from "./LogEventsGrid.vue?vue&type=script&setup=true&lang=ts"

import "./LogEventsGrid.vue?vue&type=style&index=0&id=23162c87&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23162c87"]])

export default __exports__